export const MAX_BOOKING_MONTHS_AHEAD = 18;
export const BOOKING_POLICY_TIMEZONE = 'America/New_York';

export function bookingPolicyToday(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: BOOKING_POLICY_TIMEZONE,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
    }).formatToParts(now);
    const dateParts = Object.fromEntries(
        parts
            .filter(({ type }) => type !== 'literal')
            .map(({ type, value }) => [type, Number(value)])
    );

    return new Date(dateParts.year, dateParts.month - 1, dateParts.day);
}

export function maxBookingDate(today = bookingPolicyToday()) {
    const maxDate = new Date(today);
    const targetDay = maxDate.getDate();

    maxDate.setHours(0, 0, 0, 0);
    maxDate.setDate(1);
    maxDate.setMonth(maxDate.getMonth() + MAX_BOOKING_MONTHS_AHEAD);
    maxDate.setDate(Math.min(targetDay, daysInMonth(maxDate)));

    return maxDate;
}

export function dateRangeExceedsMaxBookingDate(
    dateRange,
    today = bookingPolicyToday()
) {
    if (typeof dateRange !== 'string' || !dateRange.includes(' to ')) {
        return false;
    }

    const [checkInValue, checkOutValue] = dateRange.split(' to ', 2);
    const checkIn = parseYmd(checkInValue);
    const checkOut = parseYmd(checkOutValue);
    const maxDate = maxBookingDate(today);

    return Boolean(
        (checkIn && checkIn > maxDate) || (checkOut && checkOut > maxDate)
    );
}

function daysInMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

function parseYmd(value) {
    const match = String(value || '')
        .trim()
        .match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;

    const date = new Date(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3])
    );
    if (
        date.getFullYear() !== Number(match[1]) ||
        date.getMonth() !== Number(match[2]) - 1 ||
        date.getDate() !== Number(match[3])
    ) {
        return null;
    }

    date.setHours(0, 0, 0, 0);
    return date;
}
